// extracted by mini-css-extract-plugin
export default {"error":"Error404_error__aGz9H","error404":"Error404_error404__D04s-","errorTitle":"Error404_errorTitle__e72B6","image":"Error404_image__0ZL7t"};